import type { ReactNode } from "react";
import { ArrowRight } from "lucide-react";

interface Props {
  eyebrow: string;
  icon: ReactNode;
  children: ReactNode;
  action?: string;
  onAction?: () => void;
  className?: string;
}

export function StatusCard({ eyebrow, icon, children, action, onAction, className = "" }: Props) {
  return (
    <section className={`status-card ${className}`}>
      <div className="card-heading"><span className="card-icon">{icon}</span><h2>{eyebrow}</h2></div>
      <div className="card-body">{children}</div>
      {action && onAction ? <button className="text-action readonly-safe" onClick={onAction}>{action}<ArrowRight size={16} /></button> : null}
    </section>
  );
}
